import http from '../util/http.js'

export const domainConfigList = (text,page,pageSize = 10) => http.get('/domainConfig/list',{text,page,pageSize})
export const domainConfigDetele = (id) => http.get('/domainConfig/delete',{id})
export const domainConfigSave = (params) => http.post('/domainConfig/save',params)
export const domainConfigDataByDomain = (domain) => http.get('/domainConfig/getDataByDomain',{domain})
export const GetDetailByInsId = (institutionId) => http.get('/domainConfig/getDetailByInsId',{institutionId})
export const Welcome = () => { return http.get('/welcome') }